/** A plain string is a paragraph; a string array is a chip list. */
export type FaqBlock = string | string[]

export interface FaqItem {
  question: string
  answer: FaqBlock[]
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive the material?',
    answer: [
      'You receive digital access immediately after payment.',
      'The material is delivered in downloadable PDF format so you can use it from your phone, tablet, laptop or computer.',
      'You can also print the pages you want to use during practice.',
    ],
  },
  {
    question: 'Is this only for experienced basketball coaches?',
    answer: [
      'No.',
      'The system is designed for experienced coaches, PE teachers, volunteer coaches and parents coaching for the first time.',
      'The visual structure shows you what to set up, what to say, what players do and what to correct.',
    ],
  },
  {
    question: 'Is this only for youth basketball?',
    answer: [
      'Yes.',
      'YOUTH BASKETBALL 360™ is specifically designed for players ages 6–12.',
      'The system is divided into three development stages:',
      ['Discover — Ages 6–8', 'Develop — Ages 9–10', 'Apply — Ages 11–12'],
    ],
  },
  {
    question: 'Do I have to follow the practices exactly?',
    answer: [
      'No.',
      'The 72 practices are ready to run as written, but you can also adapt them based on:',
      ['Time', 'Number of players', 'Ability level', 'Court space', 'Equipment', 'Your coaching objective'],
    ],
  },
  {
    question: 'Does it include videos?',
    answer: [
      'No.',
      'YOUTH BASKETBALL 360™ is a visual PDF coaching system.',
      'It uses step-by-step images, diagrams, arrows, timelines and coaching cues so you can understand and apply the material without needing video.',
    ],
  },
  {
    question: 'Can I download and print the material?',
    answer: ['Yes.', 'You can download the PDFs and print the pages you want to use.'],
  },
  {
    question: 'Is this a subscription?',
    answer: ['No.', 'You make one payment and receive access to the complete system.'],
  },
  {
    question: 'Is everything in English?',
    answer: ['Yes.', 'All 6 volumes and all 5 bonuses are 100% in English.'],
  },
  {
    question: 'Do I need special equipment?',
    answer: [
      'No.',
      'The system is designed for real youth basketball environments.',
      'Many activities can be adapted for:',
      ['Limited basketballs', 'Half court', 'One basket', 'Few cones', 'Large groups'],
    ],
  },
  {
    question: 'How does the 7-day guarantee work?',
    answer: [
      'If the delivered files are incomplete, inaccessible or do not match what is described on this page, contact us within 7 days.',
      'We will review the problem and work to solve it.',
      'If we cannot solve it, you receive a full refund.',
    ],
  },
]
